import { render } from "./wave.vue?vue&type=template&id=7d879187&scoped=true"
import script from "./wave.vue?vue&type=script&lang=js"
export * from "./wave.vue?vue&type=script&lang=js"

import "./wave.vue?vue&type=style&index=0&id=7d879187&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d879187"]])

export default __exports__